import { Form, Input, Text } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { AzurePatSteps } from "@/pages/IntegrationsPage/components/molecules/AzurePatSteps"

import { FormAzureIntegrationPageComponent } from "./FormAzureIntegrationPage.types"

const INSTRUCTIONS = [1, 2, 3, 4, 5]
const SCOPES = [1, 2, 3]

export const FormAzureIntegrationPage: FormAzureIntegrationPageComponent = ({
  focusRef,
  form,
  onFieldsChange
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.connect.azure.steps"
  })
  const { t: tError } = useTranslation()
  const rules = [{ required: true, message: tError("error.requiredField") }]

  return (
    <Form layout="vertical" form={form} onFieldsChange={onFieldsChange}>
      <AzurePatSteps
        instructions={INSTRUCTIONS.map((number) => t(`generate.${number}`))}
        scopes={SCOPES.map((number) => t(`generate.6.steps.${number}`))}
      >
        <Text type="secondary">
          <Trans>{t("organizationName.description")}</Trans>
        </Text>
        <Form.Item required={false} name="organizationName" rules={rules}>
          <Input
            ref={focusRef}
            placeholder={t("organizationName.placeholder")}
          />
        </Form.Item>
        <Text type="secondary">{t("accessToken.description")}</Text>
        <Form.Item required={false} name="azureAccessToken" rules={rules}>
          <Input placeholder={t("accessToken.placeholder")} />
        </Form.Item>
      </AzurePatSteps>
    </Form>
  )
}
